import Component from './component'
import { connect } from 'react-redux'
import get from 'lodash/get'

const mapStateToProps = state => ({
  queryString: state.UI.location.search,
  data: state.UI.filters,
  screenType: get(state, 'UI.screenType', '')
})

export default connect(mapStateToProps, null)(Component)
